export default "__VITE_ASSET__bcd1e55f__"